import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    inputFilters: {},
    filtersForQueries: {},
};
const { actions, reducer } = createSlice({
    name: 'tablesFilters',
    initialState,
    reducers: {
        setInputFilters: (state, { payload }) => {
            const { tableId, value } = payload;
            if (!tableId)
                return;
            state.inputFilters[tableId] = value;
        },
        setAndApplyInputFilters: (state, { payload }) => {
            const { tableId, value } = payload;
            if (!tableId)
                return;
            state.inputFilters[tableId] = value;
            state.filtersForQueries[tableId] = value;
        },
        resetReduxTableFilters: (state, { payload: tableId }) => {
            if (!tableId)
                return;
            state.inputFilters[tableId] = [];
            state.filtersForQueries[tableId] = [];
        },
    },
});
export const { setInputFilters, resetReduxTableFilters, setAndApplyInputFilters } = actions;
export default reducer;
